export const STORE_KEY = { auth: "auth", authSession: "authSession" } as const;

export const STORE_VERSION = 1;
